import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { PiArrowRight, PiPlus } from 'react-icons/pi';
import Section, { FaqItem, FaqLinks, Grid, SectionHeading, ViewAllLink } from './faq.style';

const FAQ = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        faqs {
          category
          description
          id
          title
        }
      }
    }
  `);
  const items = (data?.appJson?.faqs || []).filter(
    (faq) => faq?.category !== 'Plans & subscriptions',
  );

  return items?.length ? (
    <Section id="faq" {...props}>
      <Container width="900px">
        <SectionHeading>
          <Text className="subtitle" content="Questions, answered" />
          <Heading content="Frequently asked questions" />
        </SectionHeading>
        <Grid>
          {items.map((faq) => (
            <FaqItem key={faq?.id}>
              <summary>
                <span>{faq?.title}</span>
                <PiPlus aria-hidden="true" />
              </summary>
              <div className="faq-answer">
                <Text content={faq?.description} />
              </div>
            </FaqItem>
          ))}
        </Grid>
        <FaqLinks>
          <ViewAllLink href="/faq">
            View the full FAQ
            <PiArrowRight aria-hidden="true" />
          </ViewAllLink>
          <ViewAllLink href="/plans">
            Compare Free and Pro
            <PiArrowRight aria-hidden="true" />
          </ViewAllLink>
        </FaqLinks>
      </Container>
    </Section>
  ) : null;
};

export default FAQ;
